import React, { FC } from 'react';
import classNames from 'classnames';
import key from 'weak-key';
import styles from './SearchBarSuggestions.module.scss';

export interface SearchBarSuggestion {
  title: string;
  placeId: string;
}

interface SearchBarSuggestionsProps {
  items: SearchBarSuggestion[];
  onItemClick: (suggestion: SearchBarSuggestion) => void;
  className?: string;
}

const SearchBarSuggestions: FC<SearchBarSuggestionsProps> = ({
  className, items, onItemClick,
}: SearchBarSuggestionsProps) => (
  <div className={classNames(className, styles.container)}>
    {items.map((item) => (
      <div
        key={key(item)}
        className={styles.item}
        onClick={(): void => onItemClick(item)}
        title={item.title}
      >
        {item.title}
      </div>
    ))}
  </div>
);

export default SearchBarSuggestions;
